import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import ThisMonthChart from './ThisMonthChart';
import ProjectionChart from './ProjectionChart';
import ChartExportButton from './ChartExportButton';
import { useBudget } from '../../context/BudgetContext';

export default function MainVisualCard() {
  const { t } = useTranslation();
  const { derived } = useBudget();
  const [tab, setTab] = useState(0);

  return (
    <Card elevation={0} sx={{ border: '1px solid #EEF0F3', borderRadius: '12px' }}>
      <CardContent sx={{ p: { xs: 2, md: 2.5 }, '&:last-child': { pb: { xs: 2, md: 2.5 } } }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Tabs
            value={tab}
            onChange={(_, v) => setTab(v)}
            sx={{
              minHeight: { xs: 44, md: 36 },
              '& .MuiTab-root': { textTransform: 'none', fontWeight: 500, minWidth: 'auto', minHeight: { xs: 44, md: 36 }, px: { xs: 1.5, md: 2 }, fontSize: '0.85rem' },
              '& .Mui-selected': { color: '#1E3A5F', fontWeight: 600 },
              '& .MuiTabs-indicator': { backgroundColor: '#1E3A5F' },
            }}
          >
            <Tab label={t('budgetPlanner.charts.tabThisMonth', 'Este mes')} />
            <Tab label={t('budgetPlanner.charts.tabProjection', 'Proyección 12 meses')} />
          </Tabs>
          <ChartExportButton containerId="budget-dashboard" />
        </Box>

        {tab === 0 && <ThisMonthChart />}
        {tab === 1 && <ProjectionChart />}
      </CardContent>
    </Card>
  );
}
